export default __webpack_public_path__ + "static/media/06_Paved_Sky.0e4699cb.mp3";